__turbopack_context__.v({
  "stepInvestment": "styles-module-scss-module__aj6xFq__stepInvestment",
});
